import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';

@Component({
    selector: 'app-modal-lista-coletas-grafico',
    templateUrl: './modal-lista-coletas-grafico.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-lista-coletas-grafico.component.css']
})
export class ModalListaColetasGraficoComponent implements OnInit {
    @ViewChild('modalListaColetasGrafico') content: any;

    @Input() resultadoColeta: ResultadoColeta;
    @Input() resultadoCriterioColeta: ResultadoCriterioColeta;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalListaColetasGrafico',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    open(resultadoColeta: ResultadoColeta, criterio: ResultadoCriterioColeta) {
        this.resultadoColeta = resultadoColeta;
        this.resultadoCriterioColeta = criterio;
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalListaColetasGrafico',
            size: 'lg'
        };
        this.modalService.open(this.content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/modal-lista-coletas-grafico/modal-lista-coletas-grafico.component.ts